//@flow
import React, { useEffect, useState } from 'react';
import type { VersionType } from 'types/product';
import { TabView } from 'components/atoms/tabView';
import { CarouselMobile } from 'components/molecules/carouselMobile';
import { find, filter } from 'lodash';
import './styles.scss';
import { ProductConfiguration } from 'components/atoms/productConfiguration';
import Table from 'react-bootstrap/Table';
import classNames from 'classnames';
import HotspotIcon from 'assets/images/map-circle-icon.png';
import { OverlayPortal } from 'components/templates/overlayPortal';
import { OverlayModal } from 'components/templates/overlayModal';

type Props = {
  versions: Array<VersionType>,
};
export const FloorPlanMobile = (props: Props) => {
  const { versions, mode, type } = props;
  const [selectedVersion, setVersion] = useState(null);
  const [selectedLevel, setLevel] = useState(null);
  const [configurations, setConfiguration] = useState(null);
  const [originalImageHeight, setHeight] = useState(1);
  const [originalImageWidth, setWidth] = useState(1);
  const [showHotspotOverlay, setShowHotspotOverlay] = useState(false);
  const [clickedHotspotValue, setClickedHotspotValue] = useState('');
  const productName = versions
    ? versions[0].product.name + versions[0].product.version
    : '';
  let minOrigFactor = 1;
  let heightOrigFactor = 1;
  let widthOrigFactor = 1;

  const floorImageClass = classNames('mobile-floor-image', {
    'full-width': mode === 'overlay',
    'has-padding': mode === 'page',
  });

  useEffect(() => {
    setVersion(versions[0]);
  }, [versions]);

  useEffect(() => {
    setLevel(selectedVersion && selectedVersion.levels[0]);
  }, [selectedVersion]);

  useEffect(() => {
    if (
      selectedLevel &&
      selectedLevel.configuration &&
      selectedLevel.configuration.length
    ) {
      selectedLevel.configuration.map((conf, idx) => {
        selectedLevel.configuration[idx].isSelected = idx === 0;
      });
      updateConfigurations(selectedLevel.configuration);
    }
  }, [selectedLevel]);

  const onSelectLevel = levelId => {
    const level = find(selectedVersion.levels, { id: levelId });
    setLevel(level);
  };

  const onSelectVersion = id => {
    const version = find(versions, { id: id });
    setVersion(version);
  };

  const renderVersions = () => {
    return (
      <ul className={'tab-section'}>
        {versions &&
          selectedVersion &&
          versions.map((version, idx) => (
            <TabView
              data={{ name: version.name, id: version.id }}
              selectedId={selectedVersion.id}
              onClick={onSelectVersion}
              key={idx}
            />
          ))}
      </ul>
    );
  };

  const onSelectConfiguration = (idx, value) => {
    // if (idx === 0) {
    //   for (let i = 1; i < selectedLevel.configuration.length; i++) {
    //     selectedLevel.configuration[i].isSelected = false;
    //   }
    // } else if (value.isSelected) {
    //   selectedLevel.configuration[idx].isSelected = false;
    // } else {
    //   for (let i = 1; i <= idx; i++) {
    //     selectedLevel.configuration[i].isSelected = true;
    //   }
    // }

    for (let i = 0; i < selectedLevel.configuration.length; i++) {
      selectedLevel.configuration[i].isSelected = i === idx;
    }

    updateConfigurations(selectedLevel.configuration);
  };

  const updateConfigurations = configurations => {
    const updatedConfigurations = filter(configurations, {
      isSelected: true,
    });
    setConfiguration(updatedConfigurations);
  };

  const setOnload = originalImage => {
    const floorplanImage = document.getElementsByClassName('full-width')[0];
    if (floorplanImage) {
      const realWidth = floorplanImage.offsetWidth; // 578px
      const realHeight = floorplanImage.offsetHeight; // 406px
      let image = new Image();
      image.src = originalImage;
      image.addEventListener('load', function() {
        setHeight(image.naturalHeight); // 600px
        setWidth(image.naturalWidth); // 800px
      });
      heightOrigFactor = realHeight / originalImageHeight; // 0.72
      widthOrigFactor = realWidth / originalImageWidth; // 0.67
      minOrigFactor = Math.max(heightOrigFactor, widthOrigFactor);
    }
  };

  const hotspotClicked = hotspot => {
    setClickedHotspotValue(hotspot);
    setShowHotspotOverlay(true);
  };

  const renderPlans = () => {
    return (
      <div className={floorImageClass}>
        {configurations &&
          configurations.map((item, idx) => (
            // <div
            //   key={idx}
            //   style={{ backgroundImage: `url(${item.listImageUrl})` }}
            //   className={'configuration-mobile-image-container'}
            // />
            <div className={'configuration-mobile'}>
              <img
                key={idx}
                // style={{ backgroundImage: `url(${item.listImageUrl})` }}
                src={item.mobileImageUrl}
                className={'configuration-mobile-image-container'}
                onLoad={setOnload(item.mobileImageUrl)}
              />
              {mode === 'overlay' &&
                item.hotSpots.map((hotspot, idx) => (
                  <img
                    key={idx}
                    src={HotspotIcon}
                    alt="icon fail"
                    className={'hotspot-icon-mobile'}
                    style={{
                      top: hotspot.y_coordinate * heightOrigFactor - 12.5,
                      left: hotspot.x_coordinate * widthOrigFactor - 12.5,
                    }}
                    onClick={() => hotspotClicked(hotspot)}
                  />
                ))}
            </div>
          ))}
      </div>
    );
  };

  const renderVersionsContent = () => {
    return (
      <div className={'mobile-version-plan'}>
        <p>Floorplan version</p>
        {renderVersions()}
      </div>
    );
  };

  const renderContent = () => {
    if (mode === 'page' && type !== 'Workcations') {
      return (
        <>
          {renderPlans()}
          {renderVersionsContent()}
        </>
      );
    } else if (mode === 'page' && type == 'Workcations') {
      return (
        <>
          {renderPlans()}
        </>
      );
    } else {
      return (
        <>
          {renderVersionsContent()}
          {renderPlans()}
        </>
      );
    }
  };

  const renderProductInfo = () => {
    return (
      <div className={'mobile-gutter product-table'}>
        <Table>
          <tbody>
            {selectedVersion.reference_saleable_area_label &&
              selectedVersion.referenceSaleableArea && (
                <tr>
                  <td> {selectedVersion.reference_saleable_area_label}</td>
                  <td>{`${selectedVersion.referenceSaleableArea} sq.ft. `}</td>
                </tr>
              )}
            {selectedVersion.carpet_area_label && selectedVersion.carpetArea && (
              <tr>
                <td> {selectedVersion.carpet_area_label}</td>
                <td>{`${selectedVersion.carpetArea} sq.ft. `}</td>
              </tr>
            )}
            {selectedVersion.built_up_label && selectedVersion.saleableArea && (
              <tr>
                <td>{selectedVersion.built_up_label}</td>
                <td>{`${selectedVersion.saleableArea} sq.ft. `}</td>
              </tr>
            )}
            {selectedVersion.outdoor_space_label &&
              selectedVersion.outdoorSpace && (
                <tr>
                  <td>{selectedVersion.outdoor_space_label}</td>
                  <td>{`${selectedVersion.outdoorSpace} sq.ft. `}</td>
                </tr>
              )}
          </tbody>
        </Table>
        <br />
        <br />
      </div>
    );
  };

  const renderOverlayContent = () => {
    return (
      <div>
        {selectedLevel && (
          <ProductConfiguration
            configurations={selectedLevel.configuration}
            onClick={onSelectConfiguration}
          />
        )}
        {selectedVersion && renderProductInfo()}
      </div>
    );
  };

  return (
    <div className={'mobile-floor-plan'} style={{ width: '100%' }}>
      {renderContent()}
      {type !== 'Workcations' && ( 
        <div style={{ height: 'auto' }}>
          {selectedVersion && selectedLevel && selectedVersion.levels && (
            <CarouselMobile
              data={selectedVersion.levels}
              selectedItem={onSelectLevel}
              selectedId={selectedLevel.id}
            />
          )}
        </div>
      )}
      {mode === 'overlay' && renderOverlayContent()}

      {showHotspotOverlay && (
        <OverlayPortal>
          <OverlayModal
            data={clickedHotspotValue}
            theme={'dark-theme'}
            type={'mobile-hotspot-overlay'}
            onClosePress={() => setShowHotspotOverlay(false)}
            breadcrumbList={[
              {
                breadcrumbName: `${productName} Model`,
                breadcrumbLink: '#',
              },
            ]}
          />
        </OverlayPortal>
      )}
    </div>
  );
};
